export var PaymentMethodValues = ['bank_transfer', 'credit_card'];
